import { Icon } from "@/components/ui/icon";
import { Menu, MenuItem, MenuItemLabel } from "@/components/ui/menu";
import { DocumentPicker } from "@/screens/image-picker/document.picker";
import { ImagePicker } from "@/screens/image-picker/image.picker";
import { InterfaceMenuProps } from "@gluestack-ui/menu/lib/types";
import { File, Image } from "lucide-react-native";
import { useState } from "react";
import { Platform } from "react-native";

export function BeneficiaryActionSheet({
  onClose,
  onUpload,
  ...rest
}: InterfaceMenuProps & {
  onUpload: (imgUri: string) => void;
}) {
  const [imageIsOpened, setImageIsOpened] = useState(false);
  const [documentIsOpened, setDocumentIsOpened] = useState(false);

  return (
    <>
      <Menu placement="bottom" offset={5} onClose={onClose} {...rest}>
        <MenuItem
          key="image"
          textValue="Upload image"
          onPress={() => setImageIsOpened(true)}
        >
          <Icon as={Image} size="sm" className="mr-2" />
          <MenuItemLabel size="sm">Upload image</MenuItemLabel>
        </MenuItem>
        <MenuItem
          key="avatar"
          textValue="Upload avatar"
          onPress={() => setDocumentIsOpened(true)}
        >
          <Icon as={File} size="sm" className="mr-2" />
          <MenuItemLabel size="sm">Upload Document</MenuItemLabel>
        </MenuItem>
      </Menu>
      {imageIsOpened && (
        <ImagePicker
          isOpened={imageIsOpened}
          isCamera={false}
          type="beneficiary_document"
          onClose={(img) => {
            setImageIsOpened(false);
            if (!img) {
              return;
            }

            onUpload(img.uri);
          }}
        />
      )}
      {documentIsOpened && (
        <DocumentPicker
          isOpened={documentIsOpened}
          type="beneficiary_document"
          onClose={(uri) => {
            setImageIsOpened(false);
            if (!uri) {
              return;
            }

            onUpload(uri);
          }}
        />
      )}
    </>
  );
}
